import React, { useMemo } from 'react';
import classNames from 'classnames';
import MsgConfigSection from '../msg-config-section';
import { CorpType } from '@libs/shared';
import { authModel } from '../../../../../../models';
import { platformIntl } from '../../../../../../constants';
import { MessageConfigItem } from '../../../../interfaces';

interface IntegrateMsgConfigProps {
    className?: string;
    config?: MessageConfigItem;
    onUpdateConfig: (config: MessageConfigItem) => void;
}

/**
 * 用量提醒-集成模式消息提醒（钉钉提醒、企微提醒、飞书提醒）
 * @see FXD-54226
 */
const IntegrateMsgConfig: React.FC<IntegrateMsgConfigProps> = (props) => {
    const { className, config, onUpdateConfig } = props;

    const integrateCheckText = useMemo(() => {
        switch (authModel.currentCorpType) {
            case CorpType.DingTalk:
                return platformIntl.get('msg.integrate.notify.dingtalk');
            case CorpType.WxWork:
                return platformIntl.get('msg.integrate.notify.wxwork');
            case CorpType.Lark:
                return platformIntl.get('msg.integrate.notify.lark');
            default:
                return platformIntl.get('msg.integrate.notify.wechat');
        }
    }, [authModel.currentCorpType]);

    // 内置模式中的用量提醒没有微信提醒
    if (!authModel.isIntegratedCorpType || !config) {
        return null;
    }

    return (
        <MsgConfigSection
            className={classNames('fx-integrate-msg-config', className)}
            messageChannel="integrate"
            checkProps={{
                checked: config.enable,
                text: integrateCheckText,
                onCheck: (value) => {
                    onUpdateConfig({ ...config, enable: value });
                }
            }}
            receiverProps={{
                editable: false,
                receivers: config.target,
                onReceiverChange: (receiver) => {
                    onUpdateConfig({ ...config, target: receiver });
                }
            }}
        />
    );
};

export default IntegrateMsgConfig;
